module.exports = __webpack_public_path__ + "static/img/10.850e2b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/10.png
// module id = LzZ7
// module chunks = 45